"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const drag = {
    onDragStart(e, isClick, targetOffset) {
        e.preventDefault();
        isClick.current = true;
        targetOffset.current = e.clientX;
    },
    onDragEnd(e, isClick) {
        e.preventDefault();
        isClick.current = false;
    },
    onDragMove(e, isClick, targetOffset, scrollRef) {
        e.preventDefault();
        if (isClick.current && scrollRef.current) {
            const moveX = targetOffset.current - e.clientX;
            scrollRef.current.scrollLeft += moveX;
            targetOffset.current = e.clientX;
        }
    },
};
exports.default = drag;
